<script setup>
import { reactiveOmit } from "@vueuse/core";
import { TabsTrigger, useForwardProps } from "reka-ui";
import { cn } from "@/lib/utils";

const props = defineProps({
  value: { type: [String, Number], required: true },
  disabled: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, "class");

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <TabsTrigger
    v-bind="{ ...forwardedProps, ...$attrs }"
    :class="
      cn(
        'vf-inline-flex vf-items-center vf-justify-center vf-whitespace-nowrap vf-px-3 vf-py-3 vf-text-sm vf-font-medium',
        'vf-ring-offset-background vf-transition-all focus-visible:vf-outline-none focus-visible:vf-ring-2 focus-visible:vf-ring-ring',
        'focus-visible:vf-ring-offset-2 disabled:vf-pointer-events-none disabled:vf-opacity-50 vf-border-transparent',
        'data-[state=active]:vf-text-primary-500 vf-relative',
        'data-[state=active]:after:vf-absolute data-[state=active]:after:vf-bottom-0 data-[state=active]:after:vf-w-full',
        'data-[state=active]:after:vf-h-[3px] data-[state=active]:after:vf-bg-primary-500 data-[state=active]:after:vf-rounded-t-lg',
        props.class
      )
    "
  >
    <span class="truncate">
      <slot />
    </span>
  </TabsTrigger>
</template>
